export default __webpack_public_path__ + "static/media/B52_12.854e8d0f.webp";